/**
 * Specific colors for the marketing website.
 * Those are not included in our geleral design system.
 */
export const WEB_RED_REG = '#FF4473';
export const WEB_RED_MID = '#FF7195';
export const WEB_RED_LT = '#FFB5C8';
export const WEB_RED_EXTRA_LIT = '#FFDCE5';

export const WEB_PURPLE_REG = '#181646';
export const WEB_PURPLE_MID = '#333070';
export const WEB_PURPLE_LT = '#6864CE';
export const WEB_PURPLE_EXTRA_LIT = '#A09CFB';

export const WEB_GREY_DK = '#686878';
export const WEB_GREY_REG = '#ACACBB';
export const WEB_GREY_LT = '#F7F7F9';

export const WEB_WHITE_REG = '#FFF';

export const WEB_ORANGE_REG = '#FFAC70';
